import React, { useState, useEffect } from "react";
import jobData from "../../data/staff.json";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./JobVacancy.css";
import FadeUp from "../FadeUp/FadeUp";

const JobVacancy = ({ isAlbanian, lenis }) => {
  const [jobVacancies, setJobVacancies] = useState([]);

  useEffect(() => {
    setJobVacancies(jobData);
  }, []);

  const [visibleJobs, setVisibleJobs] = useState(3);

  const loadMoreJobs = () => {
    setVisibleJobs((prev) => prev + 3);
  };

  return (
    <div>
      <div className="jobvacancy-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="jobvacancy-content">
            <div className="jobvacancy-left">
              <div className="jobvacancy-title">
                {isAlbanian ? "Pozicione Vakante" : "Job Vacancies"}
              </div>
            </div>
            <div className="jobvacancy-card-list">
              {jobVacancies.length === 0 ? (
                <p className="no-vacancies">
                  {isAlbanian
                    ? "Nuk ka asnjë pozicion vakant për momentin."
                    : "There are no job vacancies listed yet."}
                </p>
              ) : (
                jobVacancies.slice(0, visibleJobs).map((job) => (
                  <FadeUp key={jobVacancies.staff_id}>
                    <div className="jobvacancy-row" key={job.staff_id}>
                      <div className="jobvacancy-card-stable">
                        <div className="jobvacancy-card-background-stable">
                          ""
                        </div>
                        <div className="jobvacancy-card-content-stable">
                          <img
                            src="/vilallogonav.png"
                            alt="logo-nav"
                            className="jobvacancy-nav-logo"
                          />
                        </div>
                      </div>

                      <Link
                        style={{ textDecoration: "none" }}
                        className="jobvacancy-card"
                        key={job.staff_id}
                        to={`/jobdetails/${job.staff_id}`}
                        onClick={(e) => {
                          if (!e.ctrlKey && !e.metaKey) {
                            e.preventDefault();
                            window.location.href = `/jobdetails/${job.staff_id}`;
                          }
                        }}
                      >
                        <div className="jobvacancy-card-background">""</div>
                        <div className="jobvacancy-card-content">
                          <h3>
                            {isAlbanian ? job.titulli_staf : job.staff_title}
                          </h3>
                        </div>
                      </Link>
                    </div>
                  </FadeUp>
                ))
              )}
            </div>
            {jobVacancies.length > visibleJobs && (
              <div className="load-more-jobs-container">
                <button
                  className="load-more-jobs-button"
                  onClick={loadMoreJobs}
                >
                  {isAlbanian ? "Shiko më shumë" : "Load More"}
                </button>
              </div>
            )}
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default JobVacancy;
